import { ExclamationCircleFilled } from '@ant-design/icons';
import LOCALS from 'commons/locals';
import { Trans } from 'react-i18next';
import { isTestEnvironment } from 'utils/is-production-environment';

const TestEnvironmentBanner = () => {
  if (!isTestEnvironment()) return null;

  return (
    <div className="flex-1 flex justify-center px-2 min-w-0">
      <div className="flex items-center gap-1.5 bg-red-600 text-white px-4 py-1.5 rounded-md font-semibold text-sm sm:text-base shadow-md">
        <ExclamationCircleFilled className="text-base sm:text-lg shrink-0" />
        <span className="whitespace-nowrap">
          <Trans i18nKey={LOCALS.test_environment_warning} />
        </span>
      </div>
    </div>
  );
};

export default TestEnvironmentBanner;
